import React, { useMemo } from 'react'
import { Phase } from '../../configLookup/components/Props';
import { handleEdges, handleNodes } from './Functions';
import ReactFlow, { MiniMap, Background, Controls } from 'reactflow';
import 'reactflow/dist/style.css';
import dagre from 'dagre';
import PhaseNode from './PhaseNode';
import styles from "../configInfo.module.css";
import { VegaButtonCircle, VegaFlex, VegaFont, VegaTooltip } from '@globalpayments/vega-react';

interface Props {
    phases: Phase[],
    setPhase: (phase : Phase) => any,
}

const Phases:React.FC<Props> = ( { phases, setPhase } ) => {
  const nodeTypes = useMemo(() => ({ phaseNode: PhaseNode }), []);
  phases.sort((a, b) => a.ordinal < b.ordinal ? -1 : a.ordinal > b.ordinal ? 1 : 0) // sorts so index is the same as id

  const onNodeClick = (event:any, node: any) => {
    const selectedPhase = phases[node.id]
    setPhase(selectedPhase)
  }  

  const dagreGraph = new dagre.graphlib.Graph();
  dagreGraph.setDefaultEdgeLabel(() => ({}));

  const nodeWidth = 450;
  const nodeHeight = 150;
  const nodes = handleNodes(phases, true)
  const edges = handleEdges(phases)

  const getLayoutedElements = (nodes: any, edges: any, direction = 'TB') => {
    dagreGraph.setGraph({ rankdir: direction, edgesep: 10, ranksep: 30, nodesep: 60});
  
    nodes.forEach((node: { id: string; }) => {
      dagreGraph.setNode(node.id, { width: nodeWidth, height: nodeHeight });
    });
  
    edges.forEach((edge: { source: string; target: string }) => {
      dagreGraph.setEdge(edge.source, edge.target);
    });
  
    dagre.layout(dagreGraph);
  
    nodes.forEach((node: { id: string; targetPosition: string; sourcePosition: string; position: { x: number; y: number; }; }) => {
      const nodeWithPosition = dagreGraph.node(node.id);
      node.targetPosition = 'top';
      node.sourcePosition = 'bottom';
  
      // We are shifting the dagre node position (anchor=center center) to the top left
      // so it matches the React Flow node anchor point (top left).
      node.position = {
        x: nodeWithPosition.x - nodeWidth / 2,
        y: nodeWithPosition.y - nodeHeight / 2,
      };
  
      return node;
    });
  
    return { nodes, edges };
  };

  const {nodes: layoutNodes, edges: layoutEdge} = getLayoutedElements(nodes, edges)

  return (
      <VegaFlex direction="col" gap="size-8">
        <VegaFlex alignItems="center" gap="size-4">
          <VegaFont as="h2" color="text-primary" variant="font-h4">Phases</VegaFont>
          <VegaTooltip placement="top" text="Phases with a blue outline have visibility criteria." trigger="hover">
            <VegaButtonCircle
              icon="fa-regular fa-circle-info"
              label="About phase outlines"
              size="small"
              variant="icon-only"
            />
          </VegaTooltip>
        </VegaFlex>
      <div className={styles.reactPhases}>
          <ReactFlow nodeTypes={nodeTypes} nodes={layoutNodes} edges={layoutEdge} onNodeClick={onNodeClick} fitView >
            <Background />
            <MiniMap style={{height:100}} zoomable pannable/>
            <Controls />
          </ReactFlow>
      </div>
      </VegaFlex>
  )
}

export default Phases